import { css } from '@emotion/css';
import { Layout } from 'antd';
import type { ReactNode } from 'react';
import { AisSessionMenu } from './ais/AisSessionMenu.tsx';
import { useAisIdentity } from './ais/useAisIdentity.ts';
import { AppHeader } from './components/AppHeader';
import { Sidebar } from './components/Sidebar';
import { HeaderActions } from './HeaderActions.tsx';
import { useCurrentContextStore } from './hooks/store/useCurrentContextStore.ts';
import { useThemeStore } from './hooks/store/useThemeStore.ts';
import { UserMenuWrapper } from './views/user/UserMenuWrapper';

const styles = {
  layout: css`
    min-height: 100vh;
  `,
  mainContent: css`
    height: calc(100vh - 64px);

    .ant-layout-content,
    .ant-layout-sider-children {
      overflow-y: auto;
    }
  `,
};

// The header and the sidebar around the page
export const AppFrame = ({ children }: { children?: ReactNode }) => {
  const aisIdentity = useAisIdentity();
  const { currentDoctorId } = useCurrentContextStore();
  const { theme } = useThemeStore();

  return (
    <Layout className={styles.layout}>
      <AppHeader
        actions={currentDoctorId ? <HeaderActions aisSession={!!aisIdentity} /> : null}
        userActions={
          <>
            <AisSessionMenu />
            <UserMenuWrapper />
          </>
        }
        theme={theme}
      />
      <Layout className={styles.mainContent}>
        <Sidebar aisSession={!!aisIdentity} />
        {children}
      </Layout>
    </Layout>
  );
};
